import { useState } from "react";
import { parseWufooCSV } from "./parseWufooCSV";
export var useUserCreateFormFields = function () {
    var _a = useState(""), email = _a[0], setEmail = _a[1];
    var _b = useState(""), firstName = _b[0], setFirst = _b[1];
    var _c = useState(""), lastName = _c[0], setLast = _c[1];
    var _d = useState(""), phone = _d[0], setPhone = _d[1];
    var _e = useState(""), city = _e[0], setCity = _e[1];
    var _f = useState(""), state = _f[0], setState = _f[1];
    var _g = useState(""), country = _g[0], setCountry = _g[1];
    var _h = useState(""), companyAssociation = _h[0], setCompanyAssociation = _h[1];
    var _j = useState(""), companyTitle = _j[0], setCompanyTitle = _j[1];
    var _k = useState(""), companyName = _k[0], setCompanyName = _k[1];
    var _l = useState(""), companyIndustry = _l[0], setCompanyIndustry = _l[1];
    var _m = useState(""), companyWebsite = _m[0], setCompanyWebsite = _m[1];
    var _o = useState(""), companyRevenue = _o[0], setCompanyRevenue = _o[1];
    var _p = useState(""), currentlyPurchasing = _p[0], setCurrentlyPurchasing = _p[1];
    var _q = useState(""), purchasingRegions = _q[0], setPurchasingRegions = _q[1];
    var _r = useState(""), seaweedSource = _r[0], setSeaweedSource = _r[1];
    var _s = useState(""), prodDevPhase = _s[0], setProdDevPhase = _s[1];
    var _t = useState(""), prodDescription = _t[0], setProdDescription = _t[1];
    var _u = useState(""), speciesPreferences = _u[0], setSpeciesPreferences = _u[1];
    var _v = useState(""), stabilizationPreferences = _v[0], setStabilizationPreferences = _v[1];
    var _w = useState(""), formPreferences = _w[0], setFormPreferences = _w[1];
    var _x = useState(""), purchasingTimeline = _x[0], setPurchasingTimeline = _x[1];
    var _y = useState(""), purchaseVolume = _y[0], setPurchaseVolume = _y[1];
    var _z = useState(""), purchaseVolumeForm = _z[0], setPurchaseVolumeForm = _z[1];
    var _0 = useState(""), targetPrice = _0[0], setTargetPrice = _0[1];
    var fieldList = [
        {
            name: "email",
            label: "Email",
            value: email,
            setter: setEmail,
            payloadKey: "email",
        },
        {
            name: "first",
            label: "First",
            value: firstName,
            setter: setFirst,
            payloadKey: "first_name",
        },
        {
            name: "last",
            label: "Last",
            value: lastName,
            setter: setLast,
            payloadKey: "last_name",
        },
        {
            name: "phone",
            label: "Phone",
            value: phone,
            setter: setPhone,
            payloadKey: "phone",
        },
        {
            name: "city",
            label: "City",
            value: city,
            setter: setCity,
            payloadKey: "city",
        },
        {
            name: "state",
            label: "State",
            value: state,
            setter: setState,
            payloadKey: "state",
        },
        {
            name: "country",
            label: "Country",
            value: country,
            setter: setCountry,
            payloadKey: "country",
        },
        {
            name: "companyAssociation",
            label: "Company association",
            value: companyAssociation,
            setter: setCompanyAssociation,
            payloadKey: "company_association",
        },
        {
            name: "companyTitle",
            label: "Company title",
            value: companyTitle,
            setter: setCompanyTitle,
            payloadKey: "company_title",
        },
        {
            name: "companyName",
            label: "Company name",
            value: companyName,
            setter: setCompanyName,
            payloadKey: "company_name",
        },
        {
            name: "companyIndustry",
            label: "Company industry",
            value: companyIndustry,
            setter: setCompanyIndustry,
            payloadKey: "company_industry",
        },
        {
            name: "companyWebsite",
            label: "Company website",
            value: companyWebsite,
            setter: setCompanyWebsite,
            payloadKey: "company_website",
        },
        {
            name: "companyRevenue",
            label: "Company revenue",
            value: companyRevenue,
            setter: setCompanyRevenue,
            payloadKey: "company_revenue",
        },
        {
            name: "currentlyPurchasing",
            label: "Currently purchasing",
            value: currentlyPurchasing,
            setter: setCurrentlyPurchasing,
            payloadKey: "currently_purchasing",
        },
        {
            name: "purchasingRegions",
            label: "Purchasing regions",
            value: purchasingRegions,
            setter: setPurchasingRegions,
            payloadKey: "purchasing_regions",
        },
        {
            name: "seaweedSource",
            label: "Seaweed source",
            value: seaweedSource,
            setter: setSeaweedSource,
            payloadKey: "seaweed_source",
        },
        {
            name: "prodDevPhase",
            label: "Prod dev phase",
            value: prodDevPhase,
            setter: setProdDevPhase,
            payloadKey: "prod_dev_phase",
        },
        {
            name: "prodDescription",
            label: "Prod description",
            value: prodDescription,
            setter: setProdDescription,
            payloadKey: "prod_description",
        },
        {
            name: "speciesPreferences",
            label: "Species preferences",
            value: speciesPreferences,
            setter: setSpeciesPreferences,
            payloadKey: "species_preferences",
        },
        {
            name: "stabilizationPreferences",
            label: "Stabilization preferences",
            value: stabilizationPreferences,
            setter: setStabilizationPreferences,
            payloadKey: "stabilization_preferences",
        },
        {
            name: "formPreferences",
            label: "Form preferences",
            value: formPreferences,
            setter: setFormPreferences,
            payloadKey: "form_preferences",
        },
        {
            name: "purchasingTimeline",
            label: "Purchasing timeline",
            value: purchasingTimeline,
            setter: setPurchasingTimeline,
            payloadKey: "purchasing_timeline",
        },
        {
            name: "purchaseVolume",
            label: "Purchase volume",
            value: purchaseVolume,
            setter: setPurchaseVolume,
            payloadKey: "purchase_volume",
        },
        {
            name: "purchaseVolumeForm",
            label: "Purchase volume form",
            value: purchaseVolumeForm,
            setter: setPurchaseVolumeForm,
            payloadKey: "purchase_volume_form",
        },
        {
            name: "targetPrice",
            label: "Target price",
            value: targetPrice,
            setter: setTargetPrice,
            payloadKey: "target_price",
        },
    ];
    var processWuFooCSV = function (fileData) {
        var payload = parseWufooCSV(fileData);
        fieldList.forEach(function (field) {
            field.setter(payload[field.payloadKey]);
        });
    };
    return {
        fieldList: fieldList,
        processWuFooCSV: processWuFooCSV,
        values: {
            first_name: firstName,
            last_name: lastName,
            email: email,
            phone: phone,
            country: country,
            state: state,
            city: city,
            company_association: companyAssociation,
            company_title: companyTitle,
            company_name: companyName,
            company_industry: companyIndustry,
            company_website: companyWebsite,
            company_revenue: companyRevenue,
            currently_purchasing: currentlyPurchasing,
            purchasing_regions: purchasingRegions,
            seaweed_source: seaweedSource,
            prod_dev_phase: prodDevPhase,
            prod_description: prodDescription,
            species_preferences: speciesPreferences,
            stabilization_preferences: stabilizationPreferences,
            form_preferences: formPreferences,
            purchasing_timeline: purchasingTimeline,
            purchase_volume: purchaseVolume,
            purchase_volume_form: purchaseVolumeForm,
            target_price: targetPrice,
        },
    };
};
//# sourceMappingURL=useUserCreateFormFields.js.map